import EformBaseService from '../../../../services/EformBaseService'

export default class StatutenPruefungService extends EformBaseService {

  constructor() {
    super('wbf/bwo/statutenpruefung')
  }
}
